'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildChatHeadingConfigFromType = undefined;

var _ChatHeadingConfigTypes = require('../constants/ChatHeadingConfigTypes');

var ChatHeadingConfigTypes = _interopRequireWildcard(_ChatHeadingConfigTypes);

var _CompanyChatHeadingConfig = require('../records/CompanyChatHeadingConfig');

var _CompanyChatHeadingConfig2 = _interopRequireDefault(_CompanyChatHeadingConfig);

var _UsersAndTeamsChatHeadingConfig = require('../records/UsersAndTeamsChatHeadingConfig');

var _UsersAndTeamsChatHeadingConfig2 = _interopRequireDefault(_UsersAndTeamsChatHeadingConfig);

var _OwnerChatHeadingConfig = require('../records/OwnerChatHeadingConfig');

var _OwnerChatHeadingConfig2 = _interopRequireDefault(_OwnerChatHeadingConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var buildChatHeadingConfigFromType = exports.buildChatHeadingConfigFromType = function buildChatHeadingConfigFromType(chatHeadingConfig, options) {
  switch (chatHeadingConfig) {
    case ChatHeadingConfigTypes.USERS_AND_TEAMS:
      return new _UsersAndTeamsChatHeadingConfig2.default(options);
    case ChatHeadingConfigTypes.OWNER:
      return new _OwnerChatHeadingConfig2.default(options);
    case ChatHeadingConfigTypes.COMPANY:
    default:
      return new _CompanyChatHeadingConfig2.default(options);
  }
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/chat-heading-config/builders/buildChatHeadingConfigFromType.js
// module id = 923
// module chunks = 2 3